// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KjyY","right":"styles_right__36Gl0"};